'use client';

import React from 'react';
import { Box, ButtonProps, SxProps, Theme, Typography, useTheme } from '@mui/material';
import deepmerge from 'deepmerge';
import BaseButton from '../BaseButton';
import EllipsisTypoGraphyMultiLine from '@/app/components/MUI/EllipsisTypoGraphyMultiLine';
import { CheckedIconWithOutCircle } from '@/public/icon';

interface CustomButtonProps extends ButtonProps {
    title?: string;
    onClick?: () => void;
    icon?: React.ReactNode;
    isSelected?: boolean;
}

const ButtonChooseCustom: React.FC<CustomButtonProps> = ({ title, onClick, icon, isSelected = false, sx = {}, ...other }) => {
    const theme = useTheme();
    return (
        <BaseButton
            onClick={onClick}
            // endIcon={isSelected ? <CheckIcon /> : icon}
            sx={deepmerge<SxProps<Theme>>(
                {
                    display: 'flex',
                    justifyContent: 'center',
                    px: 5,
                    alignItems: 'center',
                    position: 'relative',
                    maxWidth: '335px',
                    width: '100%',
                    minHeight: '48px',
                    backgroundColor: isSelected ? theme.palette.grayscale.gray07 : theme.palette.grayscale.gray01,
                    border: '1px solid #EEE',
                    color: isSelected ? theme.palette.grayscale.gray01 : theme.palette.grayscale.gray06,
                    padding: '0 16px',
                    '&:hover': {
                        backgroundColor: isSelected ? theme.palette.grayscale.gray07 : theme.palette.grayscale.gray02,
                        boxShadow: 'none',
                        border: '1px solid #EEE',
                    },
                },
                sx
            )}
            {...other}
        >
            <Box sx={{ width: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                <EllipsisTypoGraphyMultiLine
                    lineHeight="100%"
                    lineNumber={1}
                    width={'80%'}
                    text={title ?? ''}
                    textAlign="center"
                    variant={isSelected ? 'h2_16Bold' : 'h2_16Regular'}
                    sx={{ justifyContent: 'center', color: isSelected ? theme.palette.grayscale.gray01 : theme.palette.grayscale.gray06 }}
                />
            </Box>
            {isSelected && (
                <Box sx={{ position: 'absolute', right: 0, marginRight: 5, lineHeight: '100%' }}>
                    <CheckedIconWithOutCircle />
                </Box>
            )}
        </BaseButton>
    );
};

export default ButtonChooseCustom;
